import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { ImageThumbnailComponent, ImageThumbnailSize } from '@web/shared/ui';

@Component({
  selector: 'app-public-brand-tile',
  imports: [ImageThumbnailComponent, NgOptimizedImage],
  templateUrl: './public-brand-tile.component.html',
  styleUrl: './public-brand-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PublicBrandTileComponent {
  public readonly size = input<ImageThumbnailSize>('lg');
  public readonly name = input.required<string>();
  public readonly logoAlt = input.required<string>();
  public readonly logoSrc = input.required<string>();

  @HostBinding('attr.title')
  public get title(): string {
    return this.name();
  }
}
